import {Form} from 'antd'
import meta from './metaCm.mjs'
import Select from './SelectCm.jsx'

export const FormItemCm = props => (
    <Form.Item
        label={meta.name}
        name="cm"
        {...props}
    >
        <Select />
    </Form.Item>
)

export const FormItemCms = props => (
    <Form.Item
        label={meta.name}
        name="cms"
        {...props}
    >
        <Select multiple />
    </Form.Item>
)
